import { Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import { IconAdjustmentsHorizontal, IconCircleX, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { setCustomerFilteredData } from "store/app/customer-management/actions";
import { getRoleOptions } from "store/app/user-management/actions";

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const userStatusOption = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
]

const FilterCustomers = (props) => {

    const { open, onClose, customerFilterData } = props;

    const [isAutoOpenCustomerStatus, setIsAutoOpenCustomerStatus] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (customerFilterData) {
            setFilter(customerFilterData)
        }
        else {
            setFilter(null);
        }
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }

    const handleSelect = (e, option, name) => {
        const { label } = option || {};
        setFilter({
            ...filter,
            [name]: label,
        });
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setCustomerFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setCustomerFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'xs'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton aria-label="close" onClick={onClose}>
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    autoFocus
                                                    label="Customer Name"
                                                    fullWidth
                                                    size="small"
                                                    name='customername'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.customername}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="Email Address"
                                                    fullWidth
                                                    size="small"
                                                    name='emailaddress'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.emailaddress}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Mobile Number"
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='mobilenumber'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={filter?.mobilenumber}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label="Address"
                                                    fullWidth
                                                    size="small"
                                                    name='address'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.address}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={userStatusOption}
                                                    open={isAutoOpenCustomerStatus}
                                                    onOpen={() => setIsAutoOpenCustomerStatus(true)}
                                                    onClose={() => setIsAutoOpenCustomerStatus(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'customerstatus')}
                                                    value={filter?.customerstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Customer Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid container justifyContent={'right'}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleFilter}
                                                    size="small"
                                                    color="primary"
                                                    startIcon={<IconAdjustmentsHorizontal />}
                                                >
                                                    Apply Filters
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleFilterClear}
                                                    sx={{ ml: 2 }}
                                                    color='error'
                                                    size="small"
                                                    startIcon={<IconCircleX />}
                                                >
                                                    Clear
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    customerFilterData: state.customers.customerFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setCustomerFilteredData: (filter) => dispatch(setCustomerFilteredData(filter)),
    getRoleOptions: () => dispatch(getRoleOptions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterCustomers);